module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "components-container"
  }, [_c('el-form', {
    ref: "createdForm",
    staticClass: "small-space",
    attrs: {
      "model": _vm.createdForm,
      "label-position": "right",
      "label-width": "200px",
      "width": "100%"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "form-item-font",
    attrs: {
      "label": "编号",
      "prop": "jpBh"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "placeholder": "自动生成"
    },
    model: {
      value: (_vm.createdForm.jpBh),
      callback: function($$v) {
        _vm.$set(_vm.createdForm, "jpBh", $$v)
      },
      expression: "createdForm.jpBh"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "form-item-font",
    attrs: {
      "label": "状态"
    }
  }, [(_vm.createdForm.jpTjzt == '-1') ? _c('div', {
    staticClass: "status",
    staticStyle: {
      "background-color": "#808080"
    }
  }, [_vm._v("\n                            未保存\n                        ")]) : (_vm.createdForm.jpTjzt == '0') ? _c('div', {
    staticClass: "status",
    staticStyle: {
      "background-color": "#e6a23c"
    }
  }, [_vm._v("\n                            未提交\n                        ")]) : (_vm.createdForm.jpTjzt == '1' && _vm.createdForm.jpShzt == '') ? _c('div', {
    staticClass: "status",
    staticStyle: {
      "background-color": "#409eff"
    }
  }, [_vm._v("\n                            待审核\n                        ")]) : (_vm.createdForm.jpShzt == '1') ? _c('div', {
    staticClass: "status",
    staticStyle: {
      "background-color": "#67c23a"
    }
  }, [_vm._v("\n                            审核通过\n                        ")]) : (_vm.createdForm.jpShzt == '2') ? _c('div', {
    staticClass: "status",
    staticStyle: {
      "background-color": "#f56c6c"
    }
  }, [_vm._v("\n                            审核驳回\n                        ")]) : _c('div')])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "form-item-font",
    attrs: {
      "label": "起效学年"
    }
  }, [_c('el-select', {
    staticClass: "formInput",
    attrs: {
      "placeholder": "请选择起效学年",
      "disabled": _vm.isEdit
    },
    on: {
      "change": _vm.handlechange
    },
    model: {
      value: (_vm.createdForm.jpXn),
      callback: function($$v) {
        _vm.$set(_vm.createdForm, "jpXn", $$v)
      },
      expression: "createdForm.jpXn"
    }
  }, _vm._l((_vm.terms), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "form-item-font",
    attrs: {
      "label": "学制"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.createdForm.institution),
      callback: function($$v) {
        _vm.$set(_vm.createdForm, "institution", $$v)
      },
      expression: "createdForm.institution"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "form-item-font",
    attrs: {
      "label": "专业名称（代码）",
      "prop": "jpZydm"
    }
  }, [_c('el-select', {
    staticClass: "formInput",
    attrs: {
      "placeholder": "请选择专业名称（代码）",
      "disabled": _vm.isEdit,
      "filterable": ""
    },
    on: {
      "change": _vm.handlechange
    },
    model: {
      value: (_vm.createdForm.jpZydm),
      callback: function($$v) {
        _vm.$set(_vm.createdForm, "jpZydm", $$v)
      },
      expression: "createdForm.jpZydm"
    }
  }, _vm._l((_vm.majors), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "form-item-font",
    attrs: {
      "label": "专业别名",
      "prop": "jpZybm"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.editDisableState
    },
    model: {
      value: (_vm.createdForm.jpZybm),
      callback: function($$v) {
        _vm.$set(_vm.createdForm, "jpZybm", $$v)
      },
      expression: "createdForm.jpZybm"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "form-item-font",
    attrs: {
      "label": "编制人"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "placeholder": "自动生成"
    },
    model: {
      value: (_vm.createdForm.userName),
      callback: function($$v) {
        _vm.$set(_vm.createdForm, "userName", $$v)
      },
      expression: "createdForm.userName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "form-item-font",
    attrs: {
      "label": "发布日期"
    }
  }, [_c('el-date-picker', {
    staticClass: "formInput",
    attrs: {
      "value-format": "yyyy-MM-dd",
      "disabled": _vm.editDisableState,
      "placeholder": "请选择日期"
    },
    model: {
      value: (_vm.createdForm.jpFbrq),
      callback: function($$v) {
        _vm.$set(_vm.createdForm, "jpFbrq", $$v)
      },
      expression: "createdForm.jpFbrq"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticClass: "form-item-font",
    attrs: {
      "label": "指定班级",
      "prop": "jpGlbjbh"
    }
  }, [_c('el-select', {
    staticClass: "formInput",
    attrs: {
      "disabled": _vm.editDisableState,
      "placeholder": "",
      "multiple": "",
      "filterable": ""
    },
    model: {
      value: (_vm.createdForm.jpGlbjbh),
      callback: function($$v) {
        _vm.$set(_vm.createdForm, "jpGlbjbh", $$v)
      },
      expression: "createdForm.jpGlbjbh"
    }
  }, _vm._l((_vm.classInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticClass: "form-item-font",
    attrs: {
      "label": "入学要求",
      "prop": "jpRxyq"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.editDisableState
    },
    model: {
      value: (_vm.createdForm.jpRxyq),
      callback: function($$v) {
        _vm.$set(_vm.createdForm, "jpRxyq", $$v)
      },
      expression: "createdForm.jpRxyq"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-row', [_c('div', {
    staticClass: "titles"
  }, [_c('span', {
    staticClass: "fonts"
  }, [_vm._v("培养目标")])])]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 5,
        maxRows: 5
      },
      "disabled": _vm.editDisableState,
      "maxlength": "1000",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.createdForm.jpPymb),
      callback: function($$v) {
        _vm.$set(_vm.createdForm, "jpPymb", $$v)
      },
      expression: "createdForm.jpPymb"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a5e934e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/teachingManage/teachingScheme/teachingForm.vue
// module id = 1812
// module chunks = 502